function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import { TableMenu } from "./Table.menu";
import { utils, constants } from "zebulon-controls";
import { computeData } from "./utils/compute.data";
import { hasParent, getUpdatedRows } from "./utils/utils";
import { buildPasteArray, getSelection } from "./utils/copy.paste";
import { manageRowError, rollback, getRowStatus, setStatus } from "./utils/utils";

export var TableEvent = function (_TableMenu) {
  _inherits(TableEvent, _TableMenu);

  function TableEvent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TableEvent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableEvent.__proto__ || Object.getPrototypeOf(TableEvent)).call.apply(_ref, [this].concat(args))), _this), _this.closeOpenedWindows = function (keepSearch, column) {
      if (_this.state.openedFilter) {
        _this.setState({ openedFilter: undefined });
      }
      if (_this.state.text.top !== undefined && !(column && column.dataType === "text")) {
        _this.setState({ text: {} });
      }
      if (_this.state.detail.content !== undefined) {
        _this.setState({ detail: {} });
      }
      if (_this.state.toolTip !== undefined) {
        _this.setState({ toolTip: undefined });
      }
      if (!keepSearch && _this.state.search !== undefined) {
        _this.setState({ search: undefined });
      }
      if (_this.contextualMenu) {
        _this.contextualMenu.close();
      }
    }, _this.fKeyMap = {
      f12: "save",
      f11: "filter",
      f10: "refresh"
    }, _this.toggleFilter = function () {
      if (_this.hasFocus) {
        var element = document.getElementById("filter: " + _this.props.id + "--" + _this.state.selectedRange.end.columns);
        if (element && element.children[0]) {
          element.children[0].focus();
          _this.hasFocus = false;
        }
      } else {
        document.activeElement.blur();
        _this.hasFocus = true;
        _this.setState({ selectedRange: _this.state.selectedRange });
      }
    }, _this.handleKeyDown = function (e) {
      // a voir
      var keyCode = e.which || e.keyCode;
      var key = utils.keyMap[keyCode];
      if (key === undefined) {
        return;
      }
      var _this$state = _this.state,
          openedFilter = _this$state.openedFilter,
          detail = _this$state.detail;

      var isFilter = hasParent(document.activeElement, "filter");
      if (key === "Escape") {
        if (openedFilter) {
          _this.hasFocus = true;
        }
        _this.closeOpenedWindows();
      }
      if (key === "Tab" && (openedFilter || detail.content || isFilter)) {
        _this.hasFocus = false;
        return false;
      }
      //function Keys
      if (keyCode > 112 && keyCode < 124) {
        var action = _this.state.meta.table.actions.find(function (action) {
          return action.key === key;
        });
        if (action) {
          e.preventDefault();
          _this.handleAction(action);
        }
        // else if (key === "f11") {
        //   e.preventDefault();
        //   this.toggleFilter();
        // }
      }
      // const fKey = this.fKeyMap[key];
      // ctrl+F
      if (70 === (e.which || e.keyCode) && e.ctrlKey) {
        _this.hasFocus = false;
        _this.handleSearch(e);
      } else if (utils.isNavigationKey(e)) {
        if (openedFilter) {
          if (key === "Enter") {
            e.preventDefault();
            _this.hasFocus = true;
            return _this.openedFilter.onOk();
          } else {
            return _this.openedFilter.values.handleNavigationKeys(e);
          }
        } else if (isFilter && ["ArrowLeft", "ArrowRight"].includes(key)) {
          return false;
        } else if (_this.rows) {
          return _this.rows.handleNavigationKeys(e);
        }
      }
    }, _this.handleCopy = function (e) {
      utils.copy(getSelection("xls", _this.state.selectedRange, _this.state.meta.properties, _this.state.filteredData, _this.state.updatedRows, _this.state.data, _this.props.params));
    }, _this.handlePaste = function (e) {
      return buildPasteArray("xls", e.clipboardData.getData("text"), _this.state.meta.properties, _this.state.selectedRange.end, function (cell) {
        return _this.selectRange_({ start: cell, end: cell }, function (x) {
          return x;
        }, undefined, "enter");
      }, _this.onChange, _this.canQuit, _this.state.filteredData, _this.state.updatedRows, _this.state.data, _this.props.params);
    }, _this.handleSearch = function (e) {
      e.preventDefault();
      _this.setState({ search: true });
    }, _this.getDetail = function (_ref2) {
      var Detail = _ref2.Detail,
          row = _ref2.row,
          data = _ref2.data,
          meta = _ref2.meta,
          status = _ref2.status,
          params = _ref2.params,
          top = _ref2.top,
          onClose = _ref2.onClose,
          onChange = _ref2.onChange;

      return React.createElement(Detail, {
        row: row,
        data: data,
        meta: meta,
        params: params,
        status: status,
        onChange: onChange,
        close: onClose,
        top: top
      });
    }, _this.onDoubleClick = function (e, row, column) {
      if (_this.props.onDoubleClick) {
        _this.props.onDoubleClick(row, column);
      } else if (_this.doubleClickAction) {
        _this.handleAction(_this.doubleClickAction, e, row, column);
      }
    }, _this.handleAction = function (action, e, row, column) {
      if (action.statusEnable === false || action.enable === false) {
        return false;
      }
      _this.closeOpenedWindows();
      var rowIndex = _this.state.selectedRange.end.rows;
      // let row = {};
      if (!row && rowIndex !== undefined) {
        row = _this.getRow(rowIndex);
      }
      if (_this.state.selectedRange || !(action.type === "delete" || action.type === "select")) {
        if (action.type === "delete") {
          return _this.handleDelete(row);
        } else if (action.type === "insert") {
          return _this.handleNew(rowIndex || 0);
        } else if (action.type === "duplicate") {
          return _this.handleDuplicate(rowIndex || 0);
        } else if (action.type === "save") {
          return _this.props.onSave();
        } else if (action.type === "refresh") {
          _this.props.onTableChange("refresh");
        } else {
          if (action.type === "detail" && action.content) {
            _this.setState({ detail: action });
          } else if (action.action) {
            var _this$state2 = _this.state,
                selectedRange = _this$state2.selectedRange,
                updatedRows = _this$state2.updatedRows,
                data = _this$state2.data,
                meta = _this$state2.meta;

            var f = function f() {
              return action.actionFunction({
                row: row || _this.row,
                column: column,
                selectedRange: selectedRange,
                updatedRows: updatedRows,
                data: data,
                meta: meta,
                params: _this.props.params,
                action: action,
                ref: _this
              }, e);
            };
            // if changes save is required
            if (action.onTableChange) {
              _this.props.onTableChange(action.onTableChange, function (ok) {
                if (ok) {
                  f();
                }
              });
            } else {
              f();
            }
            _this.setState({ status: _this.state.status });
          }
        }
      }
    }, _this.handleDelete = function (row) {
      var status = getRowStatus(_this.state.updatedRows, row);
      if (status.deleted_) {
        status.deleted_ = false;
      } else {
        if (!status.new_) {
          rollback(_this.state.updatedRows, row.index_);
        }
        setStatus(status, "deleted_");
      }
      _this.setState({ status: _this.state.status });
      if (_this.props.onRowDelete) {
        var message = {
          row: row,
          status: status,
          meta: _this.state.meta,
          data: _this.state.data,
          params: _this.props.params
        };
        _this.props.onRowDelete(message);
      }
    }, _this.newRow = function (row, index) {
      var ok = _this.canQuit("new", function (ok) {
        if (ok) {
          _this.newRow_(row, index);
        }
      });
      if (ok) {
        _this.newRow_(row, index);
      }
    }, _this.newRow_ = function (row, index) {
      var _this$state3 = _this.state,
          selectedRange = _this$state3.selectedRange,
          updatedRows = _this$state3.updatedRows,
          filteredData = _this$state3.filteredData,
          meta = _this$state3.meta,
          data = _this$state3.data,
          scroll = _this$state3.scroll;

      var status = {
        new_: true,
        errors: {},
        rowUpdated: row,
        timeStamp: new Date().getTime()
      };
      var rows = filteredData,
          ix = index;
      updatedRows[_this.getDataLength()] = status;
      if (!meta.serverPagination) {
        rows = filteredData;
        data.push(row);
      } else {
        rows = filteredData.page;
        ix = index - filteredData.pageStartIndex;
        filteredData.pageLength++;
        filteredData.filteredDataLength++;
        filteredData.dataLength++;
      }
      rows = rows.slice(0, ix).concat(row).concat(rows.slice(ix));
      if (meta.serverPagination) {
        filteredData.page = rows;
        _this.setState({ filteredData: filteredData });
      } else {
        _this.setState({ filteredData: rows });
      }
      if (_this.onRowNew(row)) {
        var columns = (meta.visibleIndexes || [0])[0];
        var range = {
          end: { rows: selectedRange.end.rows || 0, columns: columns },
          start: {
            rows: selectedRange.end.rows,
            columns: meta.properties.length - 1
          }
        };
        var rowDirection = Math.sign(range.end.rows - (scroll.rows.startIndex || 0));
        var columnDirection = Math.sign(range.end.columns - scroll.columns.startIndex);
        _this.selectRange(range, undefined, row, "enter");
        _this.rowUpdated = true;
        _this.scrollTo(range.end.rows, rowDirection, range.end.columns, columnDirection);
      }
    }, _this.handleNew = function (index) {
      var row = { index_: _this.getDataLength() };
      //  default values
      _this.state.meta.properties.filter(function (column) {
        return column.defaultFunction;
      }).forEach(function (column) {
        return row[column.id] = column.defaultFunction({
          column: column,
          row: row,
          params: _this.props.params
        });
      });
      _this.newRow(row, index);
    }, _this.handleDuplicate = function (index) {
      if (_this.row) {
        var row = Object.assign({}, _this.row, { index_: _this.getDataLength() });
        if (_this.state.meta.table.rowId) {
          row[_this.state.meta.table.rowId] = undefined;
        }
        if (_this.state.meta.table.primaryKey) {
          row[_this.state.meta.table.primaryKey] = null;
        }
        _this.newRow(row, index);
      }
    }, _this.pagination = function (_ref3) {
      var startIndex = _ref3.startIndex,
          stopIndex = _ref3.stopIndex,
          callbackBefore = _ref3.callbackBefore,
          callbackAfter = _ref3.callbackAfter,
          filters = _ref3.filters,
          sorts = _ref3.sorts;
      var _this$state4 = _this.state,
          updatedRows = _this$state4.updatedRows,
          filteredData = _this$state4.filteredData,
          meta = _this$state4.meta;

      _this.setState({
        status: { loaded: false, loading: false, loadingPage: true }
      });
      _this.state.data({
        startIndex: startIndex,
        stopIndex: stopIndex,
        filters: filters,
        sorts: sorts,
        updatedRows: updatedRows
      }).then(function (data) {
        if (callbackBefore) {
          callbackBefore(data);
        }
        filteredData.page = data.page;
        filteredData.pageLength = data.pageLength;
        filteredData.filteredDataLength = data.filteredDataLength;
        filteredData.pageStartIndex = data.pageStartIndex;
        computeData(data.page, meta, 0);
        if (_this.props.onGetPage) {
          _this.props.onGetPage(data);
        }
        // console.log("page", startIndex, stopIndex, filteredData);
        if (callbackAfter) {
          callbackAfter(data);
        }
        _this.setState({
          filteredDataLength: filteredData.filteredDataLength,
          status: { loaded: true, loading: false, loadingPage: false }
        });
      });
    }, _this.getDataLength = function () {
      return _this.state.meta.serverPagination ? _this.state.filteredData.dataLength : _this.state.data.length;
    }, _this.getFilteredDataLength = function () {
      return _this.state.meta.serverPagination ? _this.state.filteredData.filteredDataLength : _this.state.filteredData.length;
    }, _this.getRow = function (index) {
      var rows = _this.state.filteredData;
      if (_this.state.meta.serverPagination) {
        return rows.page[index - rows.pageStartIndex] || { index_: undefined };
      } else {
        return rows[index] || { index_: undefined };
      }
    }, _this.isInPage = function (scroll) {
      return !_this.state.meta.serverPagination || scroll.startIndex >= _this.state.filteredData.pageStartIndex && scroll.startIndex + Math.ceil(_this.rowsHeight / _this.rowHeight) - 1 < _this.state.filteredData.pageStartIndex + _this.state.filteredData.pageLength;
    }, _this.paginationIsRequired = function (_ref4) {
      var startIndex = _ref4.startIndex,
          stopIndex = _ref4.stopIndex;

      return _this.state.meta.serverPagination && (startIndex < _this.state.filteredData.pageStartIndex || stopIndex >= _this.state.filteredData.pageStartIndex + _this.state.filteredData.pageLength);
    }, _this.scrollTo = function (rowIndex, rowDirection, columnIndex, columnDirection, noFocus, dataLength) {
      // console.log("scroll", rowIndex, noFocus);
      if (_this.rows && (rowDirection || columnDirection)) {
        _this.rows.scrollOnKey({ rows: rowIndex, columns: columnIndex }, null, rowDirection, columnDirection, false, dataLength);
      }
      if (noFocus) {
        _this.hasFocus = false;
      }
    }, _this.onScroll = function (scroll, cell, extention) {
      var startIndex = scroll.rows.startIndex;
      var stopIndex = startIndex + Math.ceil(_this.rowsHeight / _this.rowHeight) - 1;
      if (_this.paginationIsRequired({ startIndex: startIndex, stopIndex: stopIndex })) {
        _this.pagination({
          startIndex: startIndex,
          stopIndex: stopIndex,
          callbackAfter: function callbackAfter() {
            return _this.onScroll_(scroll, cell, extention);
          }
        });
      } else {
        _this.onScroll_(scroll, cell, extention);
      }
    }, _this.onScroll_ = function (scroll, cell, extension) {
      _this.closeOpenedWindows(true);
      var range = Object.assign({}, _this.state.selectedRange);
      if (cell) {
        range.end = cell;
        if (!extension) {
          range.start = cell;
        }
        _this.selectRange_(range, function (x) {
          return x;
        });
      }
      _this.setState({ scroll: scroll });
    }, _this.selectRange = function (range, callback, row, type, noFocus, scrollOnClick) {
      // console.log("selectRange", type, noFocus);
      if (!_this.state.status.loadingPage && !_this.state.status.loading) {
        var startIndex = range.end.rows,
            stopIndex = range.end.rows;
        if (_this.paginationIsRequired({ startIndex: startIndex, stopIndex: stopIndex })) {
          _this.pagination({
            startIndex: startIndex,
            stopIndex: stopIndex,
            callbackAfter: function callbackAfter() {
              return _this.selectRange_(range, callback || function (x) {
                return x;
              }, row, type, noFocus, scrollOnClick);
            }
          });
        } else {
          _this.closeOpenedWindows(true);
          var ok = _this.selectRange_(range, callback || function (x) {
            return x;
          }, row, type, noFocus, scrollOnClick);
          if (ok !== undefined) {
            if (callback) {
              return callback(ok);
            } else {
              return ok;
            }
          }
        }
      }
    }, _this.selectRange_ = function (range, callback, row, type, noFocus, scrollOnClick) {
      if (!_this.props.isActive && _this.props.onActivation) {
        _this.props.onActivation();
      }
      var _this$state5 = _this.state,
          selectedRange = _this$state5.selectedRange,
          scroll = _this$state5.scroll;

      var meta = _this.state.meta;
      // if (this.state.auditedRow) {
      //   selectedRange = this.state.selectedRangeAudit;
      //   scroll = this.state.scrollAudit;
      // }
      // this.hasFocus = !noFocus && !search;
      _this.hasFocus = !noFocus;
      var prevEnd = selectedRange.end;
      var prevStart = selectedRange.start;
      var endChanged = prevEnd.rows !== range.end.rows || prevEnd.columns !== range.end.columns;
      var enter = function enter(ok) {
        if (!ok) {
          callback(false);
          return false;
        }
        if (endChanged || type) {
          if (prevEnd.rows !== range.end.rows || type === "enter") {
            _this.rowUpdated = false;
            if (range.end.rows !== undefined) {
              _this.row = row || _this.getRow(range.end.rows);
              _this.previousRow = Object.assign({}, _this.row);
            } else {
              _this.row = undefined;
              _this.previousRow = undefined;
            }
          }
          _this.updated = false;
          if (range.end.rows !== undefined) {
            _this.column = meta.properties[range.end.columns];
            _this.previousValue = _this.row[_this.column.id];
            if (prevEnd.rows !== range.end.rows || type === "enter") {
              _this.onRowEnter(_this.row);
            }
            _this.onCellEnter(_this.previousValue, _this.row, _this.column);
            if (meta.properties[range.end.columns].dataType === "text") {
              _this.handleText(range.end, _this.row, _this.column);
            }
            if (scrollOnClick) {
              _this.rows.scrollOnKey({ rows: range.end.rows, columns: range.end.columns }, constants.AxisType.ROWS);
            }
          } else {
            _this.column = undefined;
            _this.previousValue = undefined;
          }
        }
        if (endChanged || prevStart.rows !== range.start.rows || prevStart.columns !== range.start.columns) {
          // if (this.state.auditedRow) {
          //   this.setState({ selectedRangeAudit: range });
          // } else {
          _this.setState({ selectedRange: range });
        }
        _this.range = range;
        // }
        callback(true);
        return true;
      };
      var quit = function quit() {
        var action = prevEnd.rows !== range.end.rows || row ? "rowQuit" : "cellQuit";
        var ok = _this.canQuit(action, enter);
        if (ok !== undefined) {
          return enter(ok);
        }
      };
      if (type === "enter") {
        return enter(true);
      }
      return quit();
    }, _this.onChange = function (value, row, column) {
      _this.updated = true;
      _this.rowUpdated = true;
      _this.tableUpdated = true;
      var _this$state6 = _this.state,
          updatedRows = _this$state6.updatedRows,
          data = _this$state6.data,
          meta = _this$state6.meta,
          dataStrings = _this$state6.dataStrings;

      delete dataStrings[row.index_];
      var status = getRowStatus(updatedRows, row);
      setStatus(status, "updated_");
      var message = {
        value: value,
        previousValue: _this.previousValue,
        row: row,
        status: status,
        column: column,
        meta: meta,
        data: data,
        params: _this.props.params
      };
      return _this.onChange_(message) && _this.props.errorHandler(message, "onChange");
    }, _this.onChange_ = function (message) {
      if (message.column.onChangeFunction && message.column.onChangeFunction(message) === false) {
        return false;
      }
      if (_this.props.onChange) {
        if (_this.props.onChange(message) === false) {
          return false;
        }
      }
      return true;
    }, _this.onCellQuit = function (message) {
      return _this.onCellQuit_(message, message.callback);
    }, _this.onCellQuit_ = function (message, callback) {
      var cellQuit = function cellQuit(ok_) {
        message.status = _this.state.updatedRows[message.row.index_];
        var onCellQuit = _this.props.onCellQuit || message.column.onQuitFunction;
        var ok = onCellQuit && ok_ ? onCellQuit(message) : ok_;
        ok = ok && _this.props.errorHandler(message, "onCellQuit");
        if (ok !== undefined && callback) {
          return callback(ok);
        }
        return ok;
      };
      var foreignObjectQuit = function foreignObjectQuit(ok_) {
        var column = message.column,
            row = message.row;

        var value = row[column.id];
        if (!(column.reference && column.foreignObjectFunction)) {
          return cellQuit(ok_);
        }
        if (utils.isNullValue(value)) {
          row[column.reference] = undefined;
          return cellQuit(ok_);
        }
        var element = document.activeElement;
        var col = column.accessor.replace("row.", "");
        col = col.replace(column.reference + ".", "");
        var filters = _defineProperty({}, col, { id: col, filterType: "starts", v: value });
        var callback = function callback(ok, data) {
          if (!ok) {
            _this.noUpdate = true;
            element = document.getElementById("cell: " + _this.props.id + "-" + row.index_ + "-" + column.index_).children[0];
          } else {
            row[column.reference] = data;
          }
          if (element) {
            _this.isOpening = true;
            element.focus();
            _this.isOpening = false;
          }
          return cellQuit(ok);
        };
        _this.props.onForeignKey(column.foreignObjectFunction, filters, callback);
        return;
      };
      if (!message.row || !message.updated) {
        return true;
      }
      return foreignObjectQuit(true);
    }, _this.onCellEnter = function (value, row, column) {
      var status = _this.state.updatedRows[row.index_];
      var message = {
        value: value,
        row: row,
        status: status,
        column: column,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      if (_this.props.onCellEnter) _this.props.onCellEnter(message);
    }, _this.onRowQuit = function (message) {
      return _this.onRowQuit_(message, message.callback);
    }, _this.checkUnicity = function (type, key, message) {
      var keyIndex = message.meta[type][message.row[key.id]];
      var error = keyIndex !== message.row.index_ && keyIndex !== undefined;
      manageRowError(message.updatedRows, message.row.index_, key, "duplicate key", error ? key.caption + ": duplicate key." : null);
      if (!error) {
        delete message.meta[type][message.previousRow[key.id]];
        message.meta[type][message.row[key.id]] = message.row.index_;
      }
    }, _this.onRowQuit_ = function (message, callback) {
      var meta = message.meta,
          updatedRows = message.updatedRows,
          row = message.row,
          rowUpdated = message.rowUpdated;

      if (rowUpdated) {
        message.status = updatedRows[row.index_];
        // mandatory data
        meta.properties.filter(function (property) {
          return property.mandatory;
        }).forEach(function (property) {
          manageRowError(updatedRows, row.index_, property, "mandatory", utils.isNullValue(property.accessorFunction ? property.accessorFunction({ row: message.row }) : row[property.id]) && !message.status.deleted_ ? (property.caption || property.id) + ": mandatory data." : null);
        });
        // duplicate key
        var pk = meta.table.pk;
        var lk = meta.table.lk;
        if (pk && !pk.hidden) {
          _this.checkUnicity("indexPk", pk, message);
        }
        if (lk && !lk.hidden) {
          _this.checkUnicity("indexLk", lk, message);
        }
        var onRowQuit = _this.props.onRowQuit || meta.row.onQuitFunction;
        var ok = onRowQuit ? onRowQuit(message) : true;
        ok = ok && _this.props.errorHandler(message, "onRowQuit", callback);

        if (ok !== undefined && callback) {
          return callback(ok);
        }
        return ok;
      }
      return true;
    }, _this.onRowEnter = function (row) {
      var message = {
        row: row,
        status: _this.state.updatedRows[row.index_],
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      if (_this.props.onRowEnter) {
        _this.props.onRowEnter(message);
      }
    }, _this.onRowNew = function (row) {
      var message = {
        row: row,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      if (_this.props.onRowNew) if (_this.props.onRowNew(message) === false) return false;
      return true;
    }, _this.onTableEnter = function () {
      var message = {
        updatedRows: _this.state.updatedRows,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      _this.tableUpdated = false;
      _this.rowUpdated = false;
      _this.updated = false;
      if (_this.props.onTableEnter) {
        _this.props.onTableEnter(message);
      }
    }, _this.beforeTableClose = function () {
      var message = {
        updatedRows: _this.state.updatedRows,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      if (_this.props.beforeTableClose) {
        _this.props.beforeTableClose(message);
      }
    }, _this.onTableClose = function () {
      var message = {
        updatedRows: _this.state.updatedRows,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      if (getUpdatedRows(_this.state.updatedRows).length) {
        _this.setState({ confirmationModal: true });
        return false;
      } else {
        if (_this.props.onTableClose) {
          _this.props.onTableClose(message);
        }
      }
    }, _this.buildMessage = function (callback) {
      var message = {
        updated: _this.updated,
        rowUpdated: _this.rowUpdated,
        tableUpdated: _this.tableUpdated,
        previousValue: _this.previousValue,
        row: _this.row,
        previousRow: _this.previousRow,
        column: _this.column,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params,
        updatedRows: _this.state.updatedRows,
        callback: callback
      };
      return message;
    }, _this.canQuit = function (action, callback) {
      var message = _this.buildMessage(callback || function () {});
      var rowQuit = function rowQuit(ok_) {
        var callback = function callback(ok) {
          if (ok) {
            _this.rowUpdated = false;
          }
          message.callback(ok);
        };
        var ok = ok_ && _this.onRowQuit_(message, callback);
        if (ok !== undefined) {
          return callback(ok);
        }
      };

      var cellQuit = function cellQuit(ok_) {
        var ok = true;
        var callback = function callback(ok) {
          if (ok) {
            _this.updated = false;
          }
          return (action === "cellQuit" ? message.callback : rowQuit)(ok);
        };
        // if (!utils.isNullValue(this.range.end.rows)) {
        ok = ok_ && _this.onCellQuit_(message, callback);
        if (ok !== undefined) {
          return callback(ok);
        }
      };
      return cellQuit(true);
    }, _this.handleErrors = function (e, rowIndex, errors) {
      if (errors.length || _this.state.toolTip) {
        var toolTip = errors.length ? {
          type: "error",
          top: e.target.offsetParent.offsetTop + rowIndex * _this.rowHeight + _this.state.scroll.rows.shift,
          left: _this.rowHeight,
          rowIndex: rowIndex,
          content: errors
        } : null;
        _this.setState({ toolTip: toolTip });
      }
    }, _this.handleText = function (cell, row, column) {
      var label = void 0;
      if (_this.state.meta.row.descriptorFunction) label = _this.state.meta.row.descriptorFunction({ row: row });
      var text = {
        top: (3 + cell.rows - _this.state.scroll.rows.startIndex) * _this.rowHeight + _this.state.scroll.rows.shift,
        left: column.position + _this.rowHeight - _this.state.scroll.columns.position,
        v: (column.accessorFunction || function (_ref5) {
          var row = _ref5.row;
          return row[column.id];
        })({ row: row }),
        label: label,
        editable: column.editable,
        row: row,
        column: column
      };
      _this.setState({ text: text });
    }, _this.handleTextChange = function (e) {
      var _this$state$text = _this.state.text,
          row = _this$state$text.row,
          column = _this$state$text.column;

      _this.setState({ text: Object.assign({}, _this.state.text, { v: e.target.value }) });
      _this.onChange(e.target.value, row, column);
    }, _this.onMetaChange = function (resetScroll) {
      var bReset = false;
      // console.log("onMetaChange", this.state.scroll.rows);
      _this.setState({
        scroll: {
          rows: _this.state.scroll.rows,
          columns: resetScroll || bReset ? {
            index: 0,
            direction: 1,
            startIndex: 0,
            shift: 0,
            position: 0
          } : _this.state.scroll.columns
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // ------------------------------------
  // Navigation
  // ------------------------------------

  //-----------------------------------------
  // buttons and actions management
  //-----------------------------------------

  // ------------------------------------------------------
  // selection and validations
  // ------------------------------------------------------

  // -------------------------------
  //  Cell events
  //  -------------------------------

  // -------------------------------
  //  row events
  //  -------------------------------

  // -------------------------------
  //  Table  events
  //  -------------------------------
  // onTableQuit_ = (message, callback) => {
  //   if (message.tableUpdated) {
  //     const onTableQuit =
  //       this.props.onTableQuit || this.state.meta.table.onQuitFunction;
  //     let ok = onRowQuit ? onRowQuit(message) : true;
  //     ok = ok && this.props.errorHandler(message, "onRowQuit", callback);

  //     if (ok !== undefined && callback) {
  //       return callback(ok);
  //     }
  //     return ok;
  //   }
  //   return true;
  // };

  // ---------------------------------------------------------
  // successive checks and validations
  // with callbacks to manage users interraction
  // and asynchronous processes
  // ---------------------------------------------------------

  //-------------------------------------------
  // end events
  // ------------------------------------------


  return TableEvent;
}(TableMenu);


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-table/lib/Table.events.js
// module id = 345
// module chunks = 0